// extracted by mini-css-extract-plugin
export default {"privacyContainer":"s3jkb8d1VjlxyG8c3293","mainText":"H0czdtfyOeuChiC5SxXJ","subText":"n5nGV5OP9k_yvWiMMjw3","saveContainer":"jQmKT3BIFyURxMBsqPrz"};